<script setup lang="ts">
import {onBeforeUnmount, onMounted, ref, watch,provide} from 'vue'
import { useToast } from "primevue/usetoast";

const toast = useToast();

const props = withDefaults(defineProps<{
    title?:string,
    modalState: boolean,
    group:string,
    message?: string,
    idForMessage?:number,
    confirmButtonLabel?:string,
    closeModalFn: () => void,
    confirmFn?: (value?: number) => void,
    radioButtons?: Array<{id: number, name: string}>,
    detail?:string,
    btnColor:string,
    titleColor:string,
    listToShow?:string[],
    position?:string,
    file?:boolean
}>(), {
    btnColor: 'red',
    titleColor: 'black'
})

const emit = defineEmits(['closeModal','add:file'])
/*  */
const fileInput = ref<HTMLInputElement>();
const selectedValue = ref<number | null>(null);
const fileTitle = ref('Концерны из файла')


const showTemplate = () => {
      toast.add({ 
      severity: 'info', 
      summary: props.message, 
      group: props.group,
      closable: false,
    });
};

const handleFileClick = () => {
    fileInput.value?.click();
};

const handleFileUpload = (event: FileList) => {
    fileTitle.value = event[0].name
    emit('add:file', event[0]);
};        

watch(()=> props.modalState, (newState, oldState) => {
    if(newState === true) {
      showTemplate();
      if (props.radioButtons?.length) {
        selectedValue.value = props.radioButtons[0].id;
      }
    } else {
        // Очищаем файл при закрытии модалки
        if (oldState === true && props.file) {
            if (fileInput.value) {
                fileInput.value.value = '';
            }
            fileTitle.value = 'Концерны из файла';
        }
        toast.removeGroup(props.group);
    }
},{deep:true});

const onClose = () => {
    // Очищаем файл при закрытии модалки
    if (fileInput.value) {
        fileInput.value.value = '';
    }
    fileTitle.value = 'Концерны из файла';
    emit('closeModal')
}

function clearFile(){
    fileTitle.value = "Концерны из файла"
    emit('add:file', {});
}


</script>

<template class="gg">
    <div>
        <Toast
        :unstyled="true"
        :group=props.group 
        @close="onClose" 
        >
        <template #message="slotProps">
            <div class="toast-content">
                <div class="mainContent">
                    <div class="primaryColor font-medium text-xl font-bold my-1 titleContainer"
                    :style="{color:props.titleColor }"
                    >{{title}}</div>
                    <div class="primaryColor font-medium text-xl my-1 flex items-center flex-items-center">
                        <i v-if="message" class="material-icons-round cursor-pointer">error</i>
                         {{ slotProps.message.summary }}
                    </div>
                    <div class="primaryColor font-medium text-xl my-1 listContainer" v-if="props.listToShow">
                        <div class="listItem" v-for="elem in props.listToShow">
                            {{ elem }}
                        </div>
                    </div>
                    <!--  -->
                    <div class="primaryColor font-medium text-xl my-1 flex items-center flex-items-center">{{ detail }}</div>
                    <!--  -->
                    <div v-if="radioButtons" class="radio-group">
                        <div v-for="el in radioButtons" :key="el.id" class="radio-item">
                            <input 
                                type="radio" 
                                :id="'radio-' + el.id"
                                :value="el.id"
                                v-model="selectedValue"
                                :name="'radio-group'"
                            />
                            <label :for="'radio-' + el.id">{{ el.name }}</label>
                        </div>
                    </div>
                    <!--  -->
                    <div v-if="file">
                        <div class="mainFilecontainer">
                            <input ref="fileInput" type="file" id="field-file"  style="display: none" accept=".xls, .xlsx" @change="(event: Event) => handleFileUpload((event.target as HTMLInputElement).files)" />
                            <div class="flex items-center mt-6 mb-4 relative" @click="() => handleFileClick()">
                                <input autocomplete="off" disabled type="text"   :placeholder="fileTitle" class="input w-full">
                                <Button 
                                    v-if="fileTitle !== 'Концерны из файла'" 
                                    icon="pi pi-times" 
                                    class="clear-file-btn" 
                                    @click="clearFile"
                                    :pt="{
                                        root: { 
                                            style: { 
                                                position: 'absolute', 
                                                right: '10%',
                                                top: '18%',  
                                                zIndex: 10,
                                                width: '24px',
                                                height: '24px',
                                                minWidth: '24px',
                                                padding: '0',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                color: '#666'
                                            } 
                                        }
                                    }" />
                                <label for="field-file" >
                                    <Button class="" :v-tooltip="'Выбрать файл'" icon="pi pi-upload" />
                                </label>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="btnGroup">
                        <!--  -->
                       
                        <Button 
                            size="small" 
                            label="Отменить" 
                            severity="secondary"
                            @click="props.closeModalFn">
                        </Button>
                        <!--  -->
                        <Button 
                            v-if="props.confirmButtonLabel"
                            size="small" 
                            :label="props.confirmButtonLabel" 
                            :pt="{
                                root: { 
                                    style: {  border:'none', color:'white', backgroundColor:props.btnColor } 
                                }
                            }"
                            @click="() => {
                                if (radioButtons && selectedValue !== null) {
                                    props.confirmFn?.(selectedValue);
                                } else {
                                    props.confirmFn?.();
                                }
                            }">
                        </Button>
                    </div>
                </div>
            </div>
        </template>
    </Toast>
    </div>
   
</template>

<style lang="scss" scoped>
.gg{
    width: 100vw;
    height: 100vh;
    position: relative;
    
}
.primaryColor{
    color:var(--primary-color)
}
.toast-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    background: var(--surface-card);
    border-radius: 10px;
    box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.5);
    z-index: 9999;
}

.mainContent {
    display: flex;
    flex-direction: column;
    width: min(500px, 90vw);
    padding: 10px;
    background: var(--surface-card);
    border-radius: 10px;
}
.titleContainer{
    display: flex;
    //justify-content: center;
    align-items: center;
}
.btnGroup {
    display: flex;
    justify-content: end;
    gap: 5px;
}
.listContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 10px;
}
.listItem {
    min-height: 10px;
    padding: 2px;
    margin: 5px;
    width: 100%;
    text-align: center;
}
.radio-group {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin: 20px 0;
}

.radio-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1rem;

    input[type="radio"] {
        width: 24px;
        height: 24px;
    }

    label {
        font-size: 1rem;
    }
}
</style>
